import React from 'react';
import { IconPropsDeprecated } from '@umanforge/common';
import { MinusSVG } from '@common_components/svg/minus.svg';

const MinusIcon: React.FC<IconPropsDeprecated> = ( { className = '', size = 7, onClick } ) => {
  return (
    <div className={`${className} w-${size} h-${size}`} onClick={onClick}>
      <MinusSVG/>
    </div>
  );
};

export { MinusIcon };
